export default __webpack_public_path__ + "static/travel-booking-platform-integration-f91ad7edfce1a2d4928fc0bfe8675829.jpg";